{
  "user": {
    "volunteerOpportunityBody": {
      "details": "Details",
      "viewShifts": "View Shifts"
    },
    "volunteerOpportunityCard": {
      "backToShifts": "Back to Shifts",
      "completeSignup": "Complete Signup",
      "date": "DATE",
      "location": "LOCATION",
      "about": "ABOUT"
    },
    "volunteerOpportunityHeader": {
      "dateAndTime": "Date & Time",
      "location": "Location"
    },
    "modalDeleteVolunteerShiftSignup": {
      "reasonForCancellation": "Reason for cancellation",
      "reasonDescription": "Optional. Max 500 characters.",
      "signupCountSingular": "{count} selected volunteer signup",
      "signupCountPlural": "{count} selected volunteer signups",
      "deleteVolunteerSignups": "Delete Volunteer Signups",
      "cancelVolunteerSignup": "Cancel Volunteer Signup",
      "deleteSelectedSignups": "Delete Selected Signups",
      "cancelAllOccurrences": "Cancel All Occurrences",
      "confirmCancelSignup": "Are you sure you want to cancel this volunteer signup?",
      "recurringCancelPrompt": "This signup is associated with a recurring volunteer shift. Would you like to cancel all occurrences or just this single occurrence?",
      "confirmDeleteSignups": "Are you sure you want to delete {signups}?",
      "recurringDeletePrompt": "You selected {signups}. At least one is associated with a recurring volunteer shift. Would you like to cancel all occurrences for recurring signups or only the selected occurrence for each recurring signup?",
      "recurringChoiceBulk": "Cancel all occurrences for recurring signups.",
      "recurringChoiceSingle": "I would like to cancel all occurrences."
    },
    "modalVolunteerCancellationPrevented": {
      "title": "Cancellation Not Available",
      "selfCancellationNotAvailable": "Self-cancellation is not available for this volunteer opportunity.",
      "contactCoordinator": "To cancel your signup, please contact the volunteer coordinator:",
      "emailLabel": "Email:",
      "whatToDoNext": "What to do next?",
      "contactSupport": "To cancel your signup, please contact your organization's support team for assistance."
    },
    "volunteerShiftCard": {
      "noRoleDefined": "No role defined",
      "optionForRecurringSignup": "Option for recurring signup",
      "shiftDoesNotRecur": "Shift does not recur",
      "youreSignedUp": "You're signed up!",
      "full": "Full",
      "signUp": "Sign Up"
    },
    "selectVolunteerOpportunity": {
      "label": "Volunteer Opportunity"
    },
    "volunteerOpportunitySignupList": {
      "selectOpportunityPrompt": "Please click a volunteer opportunity below to view all available shifts:",
      "changeSelection": "Change Selection",
      "volunteerOpportunities": "Volunteer Opportunities",
      "spotsRemaining": "{count} spots remaining",
      "full": "Full",
      "select": "Select"
    },
    "volunteerShiftList": {
      "noShiftsFound": "No shifts found for your filters selected.",
      "shiftsFillingUp": "Heads up! Shifts are filling up for this date.",
      "loadNextDay": "Click here to load the next day with available shifts."
    },
    "volunteerShiftListFilters": {
      "filterByRole": "Filter By Role",
      "selectDate": "Select date",
      "moreShiftsAvailableStarting": "More shifts available starting {date}",
      "allRoles": "All Roles"
    },
    "volunteerShiftListTable": {
      "deselect": "Deselect",
      "select": "Select",
      "colId": "ID",
      "colName": "Name",
      "colTime": "Time",
      "colSpots": "Spots",
      "colSelected": "Selected",
      "pageTitle": "Volunteer Shifts"
    },
    "volunteerShiftSignupFlow": {
      "editYourSignup": "Edit Your Signup",
      "findAShift": "Find a Shift",
      "completeSignup": "Complete Signup",
      "signupUpdatedSuccessfully": "Signup updated successfully"
    },
    "volunteerShiftSignupForm": {
      "oneTime": "One-time",
      "spotsLeft": "{count} left",
      "spotsFull": "Full",
      "changeSelectedShift": "Change Selected Shift",
      "shiftFull": "Shift Full",
      "shiftFullSelectDifferentDateOrShift": "This shift is full for the date you have selected. Please go back and select a different date or shift.",
      "signUpForThisShift": "Sign Up for This Shift",
      "registrationFailed": "Registration Failed",
      "recurringRegistrationFailedIntro": "Recurring shift registration failed because shifts on the following dates are",
      "full": "full",
      "pleaseSignupIndividually": "Please signup individually for this shift if you would like to volunteer.",
      "fullName": "Full Name",
      "pleaseEnterFullName": "Please enter your full name",
      "enterYourFullName": "Enter your full name",
      "emailAddress": "Email Address",
      "pleaseEnterValidEmail": "Please enter a valid email address",
      "enterYourEmail": "Enter your email",
      "phoneNumber": "Phone Number",
      "pleaseEnterPhoneNumber": "Please enter your phone number",
      "requiredWaivers": "Required Waivers",
      "byClickingSignUpAgreeWaivers": "By clicking \"Sign Up\" you agree to the above waivers.",
      "importantCancellationPolicy": "Important: Cancellation Policy",
      "cannotCancelYourself": "Once you sign up for this shift, you will not be able to cancel it yourself.",
      "contactCoordinatorToCancel": "If you need to cancel, please contact the volunteer coordinator at",
      "contactSupportToCancel": "If you need to cancel, please contact your organization's support team for assistance.",
      "signingUp": "Signing Up...",
      "signUpForShift": "Sign Up for Shift",
      "updateShiftSignup": "Update Shift Signup",
      "editModeDescription": "You can modify who is volunteering for this shift. The recurring registration setting cannot be changed when editing.",
      "registerWithRecurringDisabled": "If you would like to still register for the shift you have selected, please do so with Recurring Option",
      "disabled": "disabled",
      "shiftFullSelectDifferentDate": "This shift is full for the date you have selected. Please go back and select a different date.",
      "whosVolunteering": "Who's Volunteering?",
      "editModeVolunteerHint": "You can add or remove volunteers from this signup. At least one volunteer must remain selected.",
      "oneOrMoreVolunteersMustBeSelected": "One or more volunteers must be selected. If you would like to cancel this volunteer shift signup entirely, please do so from the",
      "mySignups": "My Signups",
      "section": "section.",
      "minimumVolunteerRequirement": "Minimum volunteer requirement",
      "atLeastOneVolunteerMustRemain": "At least one volunteer must remain selected for this shift. You can still add additional volunteers or replace the current one. To cancel this signup entirely, visit your",
      "page": "page.",
      "recurringRegistration": "Recurring Registration",
      "registerForAllFutureOccurrences": "Register for all future occurrences",
      "signUpAllFutureInstances": "This will sign you up for all future instances of this recurring shift",
      "recurringStatusCannotBeChanged": "Recurring status cannot be changed when editing. To modify recurring registration, please cancel this signup and create a new one.",
      "byClickingAgreeWaivers": "By clicking \"{action}\" you agree to the above waivers.",
      "update": "Update",
      "signUp": "Sign Up",
      "updating": "Updating...",
      "updateSignup": "Update Signup",
      "signupUpdated": "Signup Updated!",
      "signupComplete": "Signup Complete!",
      "signupUpdatedMessage": "Your volunteer shift signup has been successfully updated.",
      "signupCompleteMessage": "Thank you for volunteering! You're all set for this shift.",
      "emailConfirmationShortly": "You will receive an email confirmation shortly.",
      "backToShiftList": "Back to Shift List",
      "oneOrMoreVolunteers": "One or more volunteers must be selected."
    },
    "volunteerShiftSignupPreviewCard": {
      "noLocation": "No location",
      "confirmCancellation": "Confirm Cancellation"
    },
    "volunteerOpportunityIndex": {
      "volunteerOpportunities": "Volunteer Opportunities",
      "pageTitle": "Volunteer Opportunities",
      "locationFilterLabel": "Location"
    },
    "volunteerOpportunityShow": {
      "backToOpportunities": "Back to Opportunities",
      "setOpportunityImage": "Set Opportunity Image",
      "date": "DATE",
      "location": "LOCATION",
      "volunteerCoordinator": "VOLUNTEER COORDINATOR"
    },
    "volunteerShiftSignups": {
      "yourVolunteerShifts": "Your Volunteer Shifts",
      "upcomingVolunteerShifts": "Upcoming Volunteer Shifts",
      "noUpcomingShifts": "You have no upcoming shifts.",
      "allVolunteerShifts": "All Volunteer Shifts",
      "cancelSignup": "Cancel Signup",
      "colOpportunity": "Opportunity",
      "colShift": "Shift",
      "colParticipantName": "Participant Name",
      "colShiftDate": "Shift Date",
      "colShiftTime": "Shift Time",
      "colAttended": "Attended",
      "colHoursLogged": "Hours Logged",
      "signupCancelled": "Volunteer signup cancelled!",
      "pageTitle": "My Signups"
    }
  },
  "manager": {
    "volunteerShiftForm": {
      "basicInformationTitle": "Basic Information",
      "shiftNameLabel": "Shift Name *",
      "fieldRequired": "This field is required.",
      "shiftNamePlaceholder": "Enter a shift name",
      "shiftRoleLabel": "Shift Role *",
      "addRole": "Add Role",
      "createRoleTitle": "Create Role",
      "shiftRoleRequiredLabel": "Shift Role Required",
      "shiftRoleRequiredDescription": "Requires that the user has the role specified above in order to signup for this volunteer shift.",
      "shiftRoleRequiredCheckbox": "User must have the role selected above in order to register for this volunteer shift",
      "shiftDescriptionLabel": "Shift Description *",
      "scheduleInformationTitle": "Schedule Information",
      "recurringShiftLabel": "Recurring Shift",
      "isRecurringShift": "This is a recurring shift",
      "recurringStartDateLabel": "Recurring Start Date *",
      "fieldRequiredWhenRecurring": "This field is required when a shift is recurring.",
      "shiftStartDateLabel": "Shift Start Date *",
      "shiftStartDateRequired": "Shift start date is required.",
      "shiftStartTimeLabel": "Shift Start Time *",
      "shiftStartTimeRequired": "Shift start time is required.",
      "shiftEndDateLabel": "Shift End Date *",
      "shiftEndDateRequired": "Shift end date is required.",
      "shiftEndTimeLabel": "Shift End Time *",
      "shiftEndTimeRequired": "Shift end time is required.",
      "capacityPermissionsTitle": "Capacity & Permissions",
      "shiftLimitLabel": "Shift Limit *",
      "shiftLimitDescription": "Setting this to 0 will prevent anyone from signing up to this shift.",
      "allowGuestsLabel": "Allow Guests to Signup",
      "allowGuestsDescription": "If this is checked, guests will be able to sign up for this shift.",
      "allowGuestsCheckbox": "Allow guests to signup for shift",
      "entityRole": "Role"
    },
    "volunteerShiftSignupAssign": {
      "opportunityStepTitle": "1. Volunteer Opportunity",
      "selectOpportunityLabel": "Select Opportunity",
      "fieldRequired": "This field is required.",
      "shiftStepTitle": "2. Shift Selection",
      "selectOpportunityFirst": "Please select a volunteer opportunity first",
      "warningLabel": "Warning:",
      "shiftFullWarning": "This shift is currently full ({spots} spots remaining). Adding this signup will exceed the shift's capacity limit of {limit} spots.",
      "userStepTitle": "3. User Selection",
      "selectShiftFirst": "Please select a shift first",
      "fullNameLabel": "Full Name *",
      "fullNamePlaceholder": "Full Name",
      "emailLabel": "Email *",
      "guestEmailPlaceholder": "Enter an email for the guest",
      "telephoneLabel": "Telephone *",
      "phonePlaceholder": "Enter a phone number",
      "searchMemberPlaceholder": "Search by email or name",
      "selectMemberFromList": "Please search for & select a member from the list.",
      "recurringStepTitle": "4. Recurring Options",
      "registrationTypeLabel": "Registration Type",
      "singleOccurrenceOnly": "Single occurrence only",
      "singleOccurrenceDescription": "Register only for this specific shift",
      "allFutureOccurrences": "All future occurrences",
      "allFutureOccurrencesDescription": "Register for this shift and all future recurring instances",
      "emailNotificationsStepTitle": "{step}. Email Notifications",
      "notifyRegistrantLabel": "Send the registrant an email notifying them of their volunteer signup",
      "noAdminNotification": "No admin notification will be sent. Super Admins and Volunteer Managers are only notified when volunteers sign up themselves.",
      "shiftSelected": "Shift selected",
      "guestNameDisplay": "Guest: {name}",
      "memberNameEmail": "{name} ({email})",
      "registerAllFutureOccurrences": "Register for all future occurrences",
      "registrantWillBeNotified": "Registrant will be notified",
      "registrantWillNotBeNotified": "Registrant will not be notified"
    },
    "volunteerShiftSignupAssignSidebar": {
      "addSignupTitle": "Add Signup",
      "saveAndAddToSameShift": "Save & Add to Same Shift",
      "saveAndAddAnother": "Save & Add Another",
      "participantAlreadySignedUp": "This participant is already signed up for this volunteer shift.",
      "signupAssignedSuccess": "Volunteer shift signup assigned successfully!",
      "failedToAssignSignup": "Failed to assign volunteer shift signup. Please try again."
    },
    "volunteerHours": {
      "title": "Volunteer Hours",
      "guestHoursOnly": "Guest hours only",
      "pageTitle": "Volunteer Hours"
    },
    "volunteerOpportunitiesCreate": {
      "opportunityDetails": "Opportunity Details",
      "titleRequired": "Title *",
      "thisFieldIsRequired": "This field is required.",
      "enterTitlePlaceholder": "Enter a title for this opportunity",
      "descriptionRequired": "Description *",
      "eventStartEndDateRequired": "Event Start & End Date *",
      "volunteerCoordinatorName": "Volunteer Coordinator Name",
      "enterCoordinatorNamePlaceholder": "Enter the name of the coordinator",
      "volunteerCoordinatorEmail": "Volunteer Coordinator Email",
      "enterCoordinatorEmailPlaceholder": "Enter the email of the coordinator",
      "opportunityHasLocation": "This opportunity has a location",
      "locationAddressRequired": "Location Address *",
      "locationNameRequired": "Location Name *",
      "enterLocationNamePlaceholder": "Enter a name for the location that might help the volunteer",
      "selectWaivers": "Select Waivers",
      "selectWaiversDescription": "A user will need to agree to the selected waivers before signing up for this opportunity.",
      "preventUserCancellation": "Prevent users from cancelling their own signups",
      "preventUserCancellationHelp": "When enabled, users will need to contact the volunteer coordinator or support to cancel their signup.",
      "displayOnlyNoRegistration": "Display-only: no registration required",
      "displayOnlyHasShiftsWarning": "This opportunity already has shifts. They will be hidden from public sign-up while display-only mode is enabled.",
      "opportunityShifts": "Opportunity Shifts",
      "createShift": "Create Shift",
      "fillOpportunityInfoFirst": "Please fill out the opportunity information section first before creating shifts.",
      "saveOpportunity": "Save Opportunity",
      "editOpportunity": "Edit Opportunity",
      "createOpportunity": "Create Opportunity",
      "entityVolunteerOpportunity": "Volunteer opportunity",
      "pageTitle": "Create Volunteer Opportunity"
    },
    "volunteerOpportunitiesIndex": {
      "title": "Volunteer Opportunities",
      "editRecommendedOrder": "Edit Recommended Order",
      "clearRecommendedOrder": "Clear Recommended Order",
      "saveRecommendedOrder": "Save Recommended Order",
      "notApplicable": "N/A",
      "pageTitle": "Volunteer Opportunities",
      "failedToLoadItemsForReordering": "Failed to load items for reordering.",
      "recommendedOrderSaved": "Recommended order saved. Members and guests now see this order.",
      "failedToSaveOrder": "Failed to save order.",
      "recommendedOrderCleared": "Recommended order cleared. Members and guests now see automatic date order.",
      "failedToResetToNaturalOrder": "Failed to reset to natural order."
    },
    "volunteerSettings": {
      "title": "Volunteer Settings",
      "reminderSettings": "Reminder Settings",
      "disableReminderPrefix": "Disabling",
      "disableReminderEmphasis": "will",
      "disableReminderSuffix": "also apply to existing shifts. Meaning those volunteers will no longer receive a reminder.",
      "enableReminderPrefix": "Enabling will",
      "enableReminderEmphasis": "not",
      "enableReminderSuffix": "apply to existing shifts. Meaning those users will not receive a reminder.",
      "remindUsersOfUpcomingShift": "Remind users of an upcoming shift",
      "whenToRemind": "When to Remind",
      "opportunitySettings": "Opportunity Settings",
      "autoUnpublishExpiredOpportunities": "Automatically unpublish volunteer opportunities after the event end date passes",
      "pageTitle": "Volunteer Settings",
      "hoursBefore": "{hours} hours before",
      "entitySettings": "Settings"
    },
    "volunteerShiftCreate": {
      "entityVolunteerShift": "Volunteer shift",
      "pageTitleEdit": "Edit Volunteer Shift",
      "pageTitleCreate": "Create Volunteer Shift"
    },
    "volunteerShiftSignupsIndex": {
      "title": "Volunteer Signups",
      "assignVolunteerSignup": "Assign Volunteer Signup",
      "firstVolunteerSignup": "This is {name}'s first volunteer signup.",
      "deleteSignups": "Delete Signups",
      "colPhoneNumber": "Phone Number",
      "signupStatusFilterLabel": "Signup Status",
      "signupStatusActiveOption": "Active",
      "signupStatusCancelledOption": "Cancelled",
      "entityVolunteerSignup": "Volunteer signup",
      "signupDeletedSingular": "{count} volunteer signup deleted",
      "signupsDeletedPlural": "{count} volunteer signups deleted",
      "pageTitle": "Volunteer Signups"
    }
  },
  "guest": {
    "volunteerOpportunitiesIndex": {
      "title": "Volunteer Opportunities",
      "pageTitle": "Volunteer Opportunities",
      "filterLocation": "Location",
      "filterStatus": "Status",
      "optionPublished": "Published",
      "optionAllLocations": "All Locations"
    },
    "volunteerShiftSignupDestroy": {
      "cancellationNotAvailable": "Cancellation Not Available",
      "selfCancellationNotAvailable": "Self-cancellation is not available for this volunteer opportunity.",
      "contactCoordinator": "To cancel your signup, please contact the volunteer coordinator:",
      "emailLabel": "Email:",
      "whatToDoNext": "What to do next?",
      "contactSupport": "To cancel your signup, please contact your organization's support team for assistance.",
      "volunteerOpportunity": "Volunteer Opportunity",
      "volunteerShift": "Volunteer Shift",
      "shiftStartDate": "Shift Start Date",
      "shiftEndDate": "Shift End Date",
      "confirmCancellation": "Confirm Cancellation",
      "confirmCancellationPrompt": "Please confirm your cancellation for the below volunteer shift",
      "reasonForCancellation": "Reason for cancellation",
      "reasonDescription": "Optional. Max 500 characters.",
      "cancellationSuccess": "Your shift has been cancelled! An email will be sent for confirmation.",
      "pageTitle": "Cancel Signup"
    },
    "volunteerShiftLogTime": {
      "volunteerSignIn": "Volunteer Sign-In",
      "findVolunteerOpportunity": "Find Volunteer Opportunity",
      "selectOpportunityPlaceholder": "Select an opportunity...",
      "findShift": "Find Shift",
      "selectOpportunityFirst": "Please select an opportunity first before selecting the shift.",
      "selectParticipant": "Select Participant",
      "selectShiftFirst": "Please select a shift first before selecting the participant.",
      "deselect": "Deselect",
      "select": "Select",
      "colName": "Name",
      "colStartedShift": "Started Shift",
      "colEndedShift": "Ended Shift",
      "colSelected": "Selected",
      "resetShift": "Reset Shift",
      "markShiftCompleted": "Mark Shift Completed",
      "startShift": "Start Shift",
      "statusUpdated": "Status Updated",
      "shiftStatusUpdated": "Shift status updated!",
      "failedToUpdateShiftStatus": "Failed to update shift status.",
      "pageTitle": "Log Time"
    }
  }
}
